import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import PagoEntrega from './PagoEntrega.js';
import ACCESS from '../../../ACCESS.js';
// import Banco from './Banco'

class PagosEntrega extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'pago-transportista/filter', deleteUrl: 'pago-transportista/delete', deleteField: 'id', modUrl: '' },
      TableOp.Table('Pagos a transportista', [
        { label: 'Folio', id: 'id' },
        { label: 'Total', id: 'total' },
      ], [
        { id: 'edit', icon: 'edit', cb: this.onEditPago, access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA] },
        { id: 'delete', icon: 'delete', access: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA] },
      ]))
    this.table();
  }

  onEditPago = (act, row) => {
    this.setState({ modalPago: { visible: true, id_pago: row.id } });
  }

  onCreatePago = () => {
    this.setState({ modalPago: { visible: true } });
  }

  onPagoClose = () => {
    this.setState({ modalPago: { visible: false } });
  }

  onPagoSave = () => {
    this.table();
  }

  render() {
    const { modalPago = { visible: false, id_pago: null } } = this.state;
    return (
      <div>
        <div style={{ textAlign: 'right' }}>
          <Button color='primary' variant='contained' onClick={this.onCreatePago}>Crear pago</Button>
        </div>
        <div>
            <this.TableRender />
        </div>



        <Dialog
          onClose={this.onPagoClose}
          open={modalPago?.visible}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogContent dividers>
            <PagoEntrega
              idPago={modalPago?.id_pago}
              onSave={this.onPagoSave}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onPagoClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withRouter(PagosEntrega)